let language = {
    200001:"Opps, the current product does not exist.",
    200020:"Opps, products are not sku products.",
    200064:"Opps, the product is not a finished product."
};

export { language }